import Pusher from 'pusher-js'
import apiClient from '@u/apiClient'

let pusher = null
let _app = null

let setupPusher = (app_key, options) => {
  return new Promise((resolve) => {
    pusher = new Pusher(app_key, {
      useTLS: true,
      channelAuthorization: {
        customHandler: (params, callback) => {
          let formData = new FormData()
          formData.append('socket_id', params.socketId)
          formData.append('channel_name', params.channelName)
          apiClient
            .post('/api/broadcasting/auth', formData)
            .then((response) => {
              callback(false, response.data)
            })
            .catch((reason) => {
              callback(true, reason.message)
            })
        }
      },
      ...options
    })
    _app.config.globalProperties.$pusher = pusher
    resolve()
  })
}

export default {
  install(app) {
    _app = app
  },
  setupPusher
}
